import React, { useState } from "react";
import { BiCheck, BiPencil, BiSolidPencil } from "react-icons/bi";
import { FaEdit, FaTimes } from "react-icons/fa";
import { MdCheckBox, MdCheckBoxOutlineBlank, MdFactCheck } from "react-icons/md";
import { TbEdit } from "react-icons/tb";

const EditableAmount = ({ item, handlePatchOperation }) => {
    const [isEditing, setIsEditing] = useState(false); // Toggle edit mode
    const [amount, setAmount] = useState(item.amount); // Local state for input field
    const [patchedAmount, setPatchedAmount] = useState(item.amount); // Save original amount for cancel

    const toggleEdit = () => {
        setIsEditing(!isEditing); // Switch between view and edit mode
        setAmount(patchedAmount); // Reset amount on cancel
    };

    const handlePatch = () => {
        handlePatchOperation({ ...item, amount }); // Call the patch function        
        setPatchedAmount(amount); // Save the patched amount
        setIsEditing(false); // Exit edit mode
    };

    return (
        <div className="flex items-center gap-2">
            {isEditing ? (
                <div className="flex items-center gap-2">
                    {/* Input Field */}
                    <input
                        type="number"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        className="border p-1 rounded w-20"
                    />

                    {/* Confirm Checkbox */}
                    <button
                        onClick={handlePatch}
                        className="text-green-600 hover:text-green-800"
                        title="Confirm Edit"
                    >
                        <BiCheck size={20} />
                    </button>

                    {/* Cancel Icon */}
                    <button
                        onClick={toggleEdit}
                        className="text-red-600 hover:text-red-800"
                        title="Cancel Edit"
                    >
                        <FaTimes size={20} />
                    </button>
                </div>
            ) : (
                <div className="flex items-center gap-2">
                    {/* Display Amount */}
                    <p className="text-black font-bold">₹{patchedAmount}</p>

                    {/* Edit Icon */}
                    <button
                        onClick={toggleEdit}
                        className="text-blue-600 hover:text-blue-800"
                        title="Edit Amount"
                    >
                        <BiSolidPencil size={20} />
                    </button>
                </div>
            )}
        </div>
    );
};

export default EditableAmount;
